
import { Vue, Component } from "vue-property-decorator";
import createActivityDetector from "activity-detector";
import { Getter } from "vuex-class";

@Component({})
export default class Activity extends Vue {

  public dialog: boolean = false;
  public TIME_WARNING = 180 * 1000;
  public TIME_LOGOUT_AFTER_WARNING = 5 * 1000;
  private idleTimeout: any = null;
  private activityDetector: any = null;

  @Getter private currentUser: any;
  @Getter private loginType: string;

  private mounted(): void {
    this.activityDetector = createActivityDetector({ timeToIdle: this.TIME_WARNING });
    this.activityDetector.on("idle", this.idle);
    this.activityDetector.on("active", this.active);
  }

  private beforeDestroy(): void {
    this.activityDetector.stop();
  }

  private idle(): void {
    if (this.currentUser && this.loginType === "NFC") {
      this.dialog = true;
      if (this.idleTimeout) { clearTimeout(this.idleTimeout); }
      this.idleTimeout = setTimeout(() => {
        this.$store.dispatch("auth/logout");
        this.dialog = false;
      }, this.TIME_LOGOUT_AFTER_WARNING);
    }

  }

  private cancelLogOut() {
    if (this.idleTimeout) { clearTimeout(this.idleTimeout); }
    this.dialog = false;
  }

  private active(): void {
    // if (this.idleTimeout) clearTimeout(this.idleTimeout)
    // this.dialog = false
  }

}
